import { useState, useEffect } from "react";
import * as InstitutesServices from "../../services/institutes.services";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../slices/authSlice";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import DataTable from "react-data-table-component";
import PageLoader from "../Loaders/PageLoader";

const HomeWorks = () => {
  const [homeWorks, setHomeWorks] = useState(null);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);

  const { t } = useTranslation();
  let { classRoomId } = useParams();
  let dispatch = useDispatch();

  const columns = [
    {
      name: (
        <div className="text-sm font-semibold text-gray-900 ltr:ml-4 rtl:mr-4">
          {t("subject")}
        </div>
      ),
      selector: (row) => (
        <div className="ltr:ml-4 rtl:mr-4">{row?.subject}</div>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="text-sm font-semibold text-gray-900">
          {t("description")}
        </div>
      ),
      selector: (row) => row?.description,
    },
    {
      name: (
        <div className="text-sm font-semibold text-gray-900 ">{t("from")}</div>
      ),
      selector: (row) => (
        <>
          {row.fromDate
            ? format(new Date(row.fromDate), "MMM d, y, HH:mm aa")
            : "not found"}
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="text-sm font-semibold text-gray-900 ">{t("to")}</div>
      ),
      selector: (row) => (
        <>
          {row.toDate
            ? format(new Date(row.toDate), "MMM d, y, HH:mm aa")
            : "not found"}
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="text-sm font-semibold text-gray-900">{t("status")}</div>
      ),
      selector: (row) => row?.status,
    },
    {
      name: (
        <div className="text-sm font-semibold text-gray-900 ">
          {t("createdAt")}
        </div>
      ),
      selector: (row) => (
        <>
          {row.createdAt
            ? format(new Date(row.createdAt), "MMM d, y, HH:mm aa")
            : "not found"}
        </>
      ),
      sortable: true,
    },
  ];

  const getHomeWorks = async (page) => {
    setLoading(true);
    await InstitutesServices.getAllHomeworks(classRoomId, page, limit)
      .then((response) => {
        setHomeWorks(response.data.homeWorks.rows);
        setCount(response.data.homeWorks.count);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          dispatch(logout());
        }
      });
  };

  useEffect(() => {
    getHomeWorks(1);
    // eslint-disable-next-line
  }, [classRoomId, dispatch]);

  const handlePageChange = (page) => {
    getHomeWorks(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    try {
      const response = await InstitutesServices.getAllInstitutes(
        page,
        newPerPage
      );
      setHomeWorks(response.data.homeWorks.rows);
      setLimit(newPerPage);
      setLoading(false);
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(logout());
      }
    }
  };

  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-lg mt-8">
      {homeWorks ? (
        <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
          <div className="px-4 py-5 sm:px-6">
            <h3 className="text-lg font-bold leading-6 text-gray-900">
              {t("homeWorks")}
            </h3>
          </div>
          <div className="flex flex-col">
            <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                {
                  <DataTable
                    columns={columns}
                    data={homeWorks}
                    progressPending={loading}
                    progressComponent={<PageLoader />}
                    pagination
                    paginationServer
                    paginationTotalRows={count}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    fixedHeader
                    direction={
                      window.localStorage.getItem("i18nextLng") === "en"
                        ? "ltr"
                        : "rtl"
                    }
                  />
                }
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PageLoader />
      )}
    </div>
  );
};

export default HomeWorks;
